// extracted by mini-css-extract-plugin
module.exports = {"root":"Hexagon_root__1A9pA","hextop":"Hexagon_hextop__3EHp_","hex":"Hexagon_hex__3jOyD","hexbottom":"Hexagon_hexbottom__3Wu4o"};